import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";

const vUI_PlannedShipment_Fields: {[id: string]: ISearchProviderField}  = {
    WB_PLAN_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Plan Id',  columnResourceName: 'colwbId',            alignment: HorizAlignment.Left},  domainOptions: {} },
    SHIPMENT_TOTAL:            {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'PlannedShipments',     columnResourceName: 'colId',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},

};

const PlannedShipmentsSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_PLAN_ID',
        id_ui: 'WB_PLAN_ID',
        name:  'WB_PLAN_ID'
    },

    searchProviderFields: vUI_PlannedShipment_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_PlannedShipmentTotal',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const PlannedShipmentsSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "PlannedShipmentsSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Plan ID', searchProviderFieldId: 'WB_PLAN_ID', renderOptions: {}},
    ],
    profileDisplayFields: [
        'WB_PLAN_ID', 'SHIPMENT_TOTAL',
    ],

    profileSearchProvider: PlannedShipmentsSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PlannedShipments: ISearch = {
    searchName: "Find PlannedShipments",
    renderOptions: {ui5ResourceId: "PlannedShipments"},
    searchProfileIdDefault: "default",
    searchProfiles: [PlannedShipmentsSearchProfileByName]
};


export {PlannedShipments}